import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useLocation, useHistory } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

function Sidebar({ open, onClose, menuItems }) {
  const location = useLocation();
  const currentPath = location.pathname;

  const { logout } = useAuth();

  const history = useHistory();

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            position: "fixed",
            top: 115,
            width: { lg: "21%", xl: "16%" },
            background: "#0B3C6C",
          },
        },
      }}
      hideBackdrop
      ModalProps={{
        keepMounted: true,
      }}
    >
      <List>
        {menuItems &&
          menuItems.map((item, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton
                onClick={item.onClick}
                sx={{
                  "&:hover": {
                    backgroundColor: "#053462",
                    "& .MuiListItemText-primary": {
                      fontWeight: 600,
                    },
                  },
                }}
              >
                {item.icon && (
                  <ListItemIcon
                    style={{
                      color: "#FFFFFF",
                    }}
                    sx={{
                      minWidth: "35px",
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                )}
                <ListItemText
                  primary={item.label}
                  slotProps={{
                    primary: {
                      sx: {
                        fontSize: "13px",
                        fontWeight: currentPath === item.path ? 800 : 200,
                        color: "#FFFFFF",
                      },
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => history.push("/help")}
            sx={{
              "&:hover": {
                backgroundColor: "#053462",
                "& .MuiListItemText-primary": {
                  fontWeight: 600,
                },
              },
            }}
          >
            <ListItemText
              primary={"Ajuda"}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: "13px",
                    fontWeight: currentPath === "/help" ? 800 : 200,
                    color: "#9AC0E4",
                  },
                },
              }}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              "&:hover": {
                backgroundColor: "#053462",
                "& .MuiListItemText-primary": {
                  fontWeight: 600,
                },
              },
            }}
          >
            <ListItemText
              primary={"Termos de uso"}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: "13px",
                    fontWeight: 200,
                    color: "#9AC0E4",
                  },
                },
              }}
              onClick={() => window.open("/termo.html", "_blank")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => {
              logout();
              history.push("/login");
            }}
            sx={{
              "&:hover": {
                backgroundColor: "#053462",
                "& .MuiListItemText-primary": {
                  fontWeight: 600,
                },
              },
            }}
          >
            <ListItemText
              primary={"Sair do app"}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: "13px",
                    fontWeight: 200,
                    color: "#9AC0E4",
                  },
                },
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
}

export default Sidebar;
